import React from 'react'
import FieldWrapper from '../Common/FieldWrapper'
import Icon from "../../Common/Icon";

export default class File extends FieldWrapper {
  constructor() {
    super();
    this.filename = null;
    this.maxFileSize = null;
  }

  changeFileNameOnClick = (event) => {
    this.filename = (event.target.files) ? event.target.files[0].name : null;
  };

  handleOnClick = (event) => {
    if (!this.filename) return

    const { formikForm, config } = this.props;
    event.preventDefault();
    this.filename = null;
    formikForm.setFieldValue(config.name, '');
  };

  componentDidMount() {
    if (this.props.config) {
      this.maxFileSize = (this.props.config.maxSize) ? this.props.config.maxSize * 1024 * 1024 : 0;
    }
  }

  renderField() {
    let {
      formikForm, formikField, isRequired,
      config: { name, placeholder, filledplaceholder, extensions, readOnly, disabled }
    } = this.props

    placeholder = !!this.filename ? filledplaceholder : placeholder
    const accept = `.${extensions.join(',.')}`

    const listeners = {}
    if(readOnly) {
      listeners.onClick = (e) => { e.preventDefault(); }
    }

    return (
      <React.Fragment>
        {
          !this.filename ? null : (
            <span className="field__file-filename">
              <Icon iconName="document" className="field__file-svg" /> {this.filename}
            </span>
          )
        }

        <input
          className="field__input field__input--file"
          id={name}
          type="file"
          placeholder={placeholder}
          {...formikField}
          onBlur={null}
          onChange={(e) => {
            this.changeFileNameOnClick(e);
            formikField.onChange(e);
            formikForm.setFieldTouched(formikField.name, true, false);
          }}
          onClick={(e) => {
            if(readOnly || disabled) return;
            this.handleOnClick(e);
            this.setState({})
          }}
          readOnly={!!readOnly}
          disabled={!!disabled}
          accept={accept}
          aria-required={!!isRequired} />
        <label className="link field__file-label" htmlFor={name} {...listeners}>
          {placeholder}
        </label>
      </React.Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/FormTemplates/Field/File.js